// extracted by mini-css-extract-plugin
module.exports = {"container":"SetNewPass_container__eM3io","contentWrapper":"SetNewPass_contentWrapper__zWtK1","list":"SetNewPass_list__21yct","listElement":"SetNewPass_listElement__EiyVI"};